import React from 'react';
import { isEmpty } from 'lodash';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MemberPromoCode from '../../../MemberPromoCode';
import MainButton from '../../../../MUI/MainButton';
import MainTextField from '../../../../MUI/MainTextField';

import useStyles from '../../makeStyles';

const DesktopComponents = ({
  promoCode,
  setShowPromoInput,
  showPromoInput,
  setNewPromoCode,
  removeAppliedPromoCode,
  submitPromoCode,
  newPromoCode,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <>
      {!showPromoInput && !isEmpty(promoCode) && (
        <Grid item xl={6} xs={4}>
          <MemberPromoCode
            policyNumber={promoCode.policyNumber}
            setShowPromoInput={setShowPromoInput}
            showPromoInput={showPromoInput}
            removeAppliedPromoCode={removeAppliedPromoCode}
          />
        </Grid>
      )}
      {showPromoInput && (
        <Grid item xs={12} className={classes.searchInputItem}>
          <MainTextField
            variant="outlined"
            size="small"
            fullWidth
            className={classes.input}
            value={newPromoCode || ''}
            placeholder={t('promoCode.addPromoCode')}
            onChange={(event) => {
              setNewPromoCode(event.target.value);
            }}
            InputProps={{
              endAdornment: (
                <MainButton
                  size="small"
                  variant="contained"
                  color="primary"
                  disabled={!newPromoCode}
                  onClick={submitPromoCode}
                >
                  {t('promoCode.apply')}
                </MainButton>
              ),
            }}
          />
        </Grid>
      )}
    </>
  );
};

DesktopComponents.propTypes = {
  promoCode: PropTypes.shape({
    policyNumber: PropTypes.string,
  }),
  setShowPromoInput: PropTypes.func.isRequired,
  setNewPromoCode: PropTypes.func.isRequired,
  removeAppliedPromoCode: PropTypes.func.isRequired,
  submitPromoCode: PropTypes.func.isRequired,
  showPromoInput: PropTypes.bool.isRequired,
  newPromoCode: PropTypes.string,
};

DesktopComponents.defaultProps = {
  promoCode: {},
  newPromoCode: undefined,
};

export default DesktopComponents;
